import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';

import { axios } from 'lib/axios';

const updateApplicationStatus = ({ applicationID, status }) => {
  return axios.put(`/api/job_ads/applications/${applicationID}/status`, { status });
};

export const useUpdateApplicationStatus = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateApplicationStatus,
    onSuccess: () => {
      enqueueSnackbar('Application status updated', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });

      queryClient.invalidateQueries('job-ad-application');
      queryClient.invalidateQueries('job-ad-applications');
      queryClient.invalidateQueries('company-applications');
    },
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.error || 'Failed to update the application status', { variant: 'error' });
    },
  });
};
